"use client";

import { useReportWebVitals } from "next/web-vitals";
import sendToAnalytics from "./cwv";

export default function WebVitals() {
  useReportWebVitals(sendToAnalytics);

  return null;
}
